import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <p>&copy; 2025 PaintingsByClaudiu. Toate drepturile rezervate.</p>
    </footer>
  );
};

export default Footer;
